import React from 'react';
import { Button } from 'muicss/react';
import PropTypes from 'prop-types';

export default function Footer(props) {
    const {
        onCancel,
        onChangeAccount,
        isDisabled,
        includeInactives,
        onChangeAccountStates,
        isLoading,
    } = props;

    return (
        <div className={'flex justify-space-between'}>
            <div className={'flex flex-col justify-center'}>
                <div className={'custom-toggle checkbox pb-0'}>
                    <input
                        type={'checkbox'}
                        id={'one'}
                        name={'checks'}
                        value={'inactive_acc'}
                        checked={includeInactives}
                        onChange={onChangeAccountStates}
                        disabled={isLoading}
                    />
                    <label htmlFor={'one'} >Include inactive accounts</label>
                </div>
                {
                    includeInactives ?
                        <div className={'inactive-text mt-3 mui--pull-left'}>
                            Selecting an inactive account will result in inaccurate pricing
                        </div> : null
                }
            </div>

            <div className={'mui--pull-right'}>
                <Button className='mui-btn--secondary' onClick={() => onCancel(false)}>Cancel</Button>
                <Button
                    className='mui-btn--success'
                    type='button'
                    onClick={onChangeAccount}
                    disabled={isDisabled || isLoading}
                >
                    Change Account
                </Button>
            </div>
        </div>
    );
}

Footer.propTypes = {
    onCancel: PropTypes.func,
    onChangeAccount: PropTypes.func,
    isDisabled: PropTypes.bool,
    includeInactives: PropTypes.bool,
    onChangeAccountStates: PropTypes.func,
    isLoading: PropTypes.bool,
}
